<ion-app>
  <ion-router-outlet mode="ios"></ion-router-outlet>
</ion-app>